function calculatePrice(elm) {
  var price =
    parseFloat(
      $(elm)
        .closest(".delivery-modal")
        .attr("data-price")
    ) || 0;
  var delPrice = parseFloat($(elm).attr("data-price")) || 0;
  var qty =
    parseFloat(
      $(elm)
        .closest(".delivery-modal")
        .attr("data-qty")
    ) || 0;
  $(elm)
    .closest(".delivery-modal")
    .find(".price-with-delivery")
    .html(formatPrice(price / 100 * qty + delPrice / 100));
}

function formatPrice(price) {
  var formattedPrice = price
    .toFixed(2)
    .replace(".", ",")
    .replace(/(\d)(?=(\d{3})+\,)/g, "$1.");

  formattedPrice = formattedPrice.replace(",00", ",-");

  return formattedPrice;
}

$(function() {
  $(".AddToCart").click(function() {
    var self = this;
    var loaderImg = '<div class="loader"></div>';

    $(self)
      .closest(".delivery-modal")
      .find(".AddToCartText")
      .append(loaderImg);

    var did = $(this)
      .closest(".delivery-modal")
      .attr("data-did");

    if (
      $(self)
        .closest(".delivery-modal")
        .find(".AddToCartText")
        .html()
        .indexOf(loaderImg) > -1
    ) {
      if (
        $(this)
          .closest(".delivery-modal")
          .find("input[type=radio]:checked").length > 0
      ) {
        //Remove old delivery
        const itemIndex = $(self)
          .closest(".delivery-modal")
          .attr("data-del-item-index");
        console.log(itemIndex);
        $.ajax(
          "/cart/change?id=" +
            $(self)
              .closest(".delivery-modal")
            .attr("data-del-item-key") +
            "&quantity=0"
        ).done(function() {
          //Add new with pid
          $.post(
            "/cart/add.js",
            {
              quantity: 1,
              line: itemIndex,
              id: $(self)
                .closest(".delivery-modal")
                .find("input[type=radio]:checked")
                .attr("data-id"),
              properties: {
                pid: did
              }
            },
            function() {
              location.reload();
            },
            "json"
          );
        });
      }
    }
  });

  $("input[type=radio]").change(function(e) {
    calculatePrice(this);
  });

  $(".delivery-modal").on("show.bs.modal", function() {
    calculatePrice($(this).find("input[type=radio]:checked"));
    console.log(this);
  });
});
